import {
  makeBlobPostRequest,
  makeGetRequest,
  makePostRequest,
} from "./restServices";

async function fetchDevicesByFirmware(firmwareId: string) {
  try {
    const response = await makeGetRequest(
      `device/get-devices-by-firmware/${firmwareId}`
    );

    if (response.data.success) {
      return response.data.data;
    }
    throw new Error("Failed to fetch sites");
  } catch (error) {
    console.error("Error in getAllSites:", error);
    return [];
  }
}
async function fetchAlldevices(
  sortKey: string,
  sortOrder: string,
  search: string,
  filters: string[]
) {
  try {
    const response = await makePostRequest("device/get-devices", {
      sortKey,
      sortOrder,
      search,
      filters,
    });

    if (response.data.success) {
      return response.data.data;
    }
    throw new Error("Failed to fetch sites");
  } catch (error) {
    console.error("Error in getAllSites:", error);
    return [];
  }
}

async function getDeviceSettings(
  deviceId: any,
  sortKey: any,
  sortOrder: any,
  filters: any
) {
  try {
    const response = await makePostRequest(
      "device-settings-map/get-device-settings",
      {
        deviceId,
        sortKey,
        sortOrder,
        filters,
      }
    );

    if (response.data.success) {
      return response.data.data;
    }
    throw new Error("Failed to fetch device settings");
  } catch (error) {
    console.error("Error in getDeviceSettings:", error);
    return [];
  }
}
async function exportDevices(body: any): Promise<Blob> {
  return await makeBlobPostRequest("device/export", body);
}

async function addDevices(serialNumbers: string[]): Promise<any> {
  try {
    const response = await makePostRequest("device/add-multiple", {
      serialNumbers,
    });

    if (response.data.success) {
      return response.data;
    }

    throw new Error("Failed to add devices.");
  } catch (error) {
    console.error("Error in addDevices:", error);
    throw error;
  }
}

async function deleteDevice(deviceSerialNumber: string): Promise<any> {
  try {
    const response = await makePostRequest("device/delete", {
      deviceSerialNumber,
    });

    if (response.data.success) {
      return response.data;
    }

    throw new Error("Failed to delete device.");
  } catch (error) {
    console.error("Error in deleteDevice:", error);
    throw error;
  }
}

async function updateDeviceSerialNumber(
  deviceId: string,
  serialNumber: string
): Promise<any> {
  try {
    const response = await makePostRequest("device/update-serial-number", {
      deviceId,
      serialNumber,
    });

    if (response.data.success) {
      return response.data;
    }

    throw new Error("Failed to update Serial Number.");
  } catch (error) {
    console.error("Error in updateDeviceSerialNumber:", error);
    throw error;
  }
}

export {
  fetchAlldevices,
  getDeviceSettings,
  exportDevices,
  addDevices,
  deleteDevice,
  updateDeviceSerialNumber,
  fetchDevicesByFirmware,
};
